import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../utils/getAxiosCancelToken";

let cancelToken;

const getNoOfUserAccessedShotclassApplication = (
  fromDate,
  toDate,
  userGroupId
) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.REPORT.ADOPTION_REPORT.GET_NUMBER_OF_USER_ACCESSED_SHOTCLASS_APPLICATION(
      fromDate,
      toDate,
      userGroupId
    ),
    cancelToken
  );
};

export default getNoOfUserAccessedShotclassApplication;
